"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MapPinLined = function MapPinLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2a7.943 7.943 0 00-8 7.866 8.3 8.3 0 002.164 5.406l.721.868c1.467 1.763 4.45 5.351 4.726 5.679a.509.509 0 00.778 0c.276-.328 3.259-3.916 4.726-5.679l.721-.867A8.3 8.3 0 0020 9.866 7.943 7.943 0 0012 2zm5.055 12.622l-.722.867A20679.6 20679.6 0 0012 20.7l-4.333-5.209-.722-.868a7.327 7.327 0 01-1.929-4.757 6.985 6.985 0 0113.968 0 7.332 7.332 0 01-1.929 4.756zM12 6.005a4 4 0 104 4 4 4 0 00-4-4zM12 13a3 3 0 113-3 3 3 0 01-3 3z",
    "data-name": "map pin",
    fill: "currentColor"
  })));
};

var _default = MapPinLined;
exports["default"] = _default;